export enum LanguageCode {
  English = 'en',
  Mexican = 'mx',
  Spanish = 'es',
  Chinese = 'zh',
}
